<template>
  <div class='SelectSlogan'>
    <input-reg
    :value="text"
    @update:model-value="newValue => text = newValue"
    :cont="{ textAlign: 'left', flex: '1' }"
    :label="{ marginLeft: '3px', display: 'none' }"
    :input="{ fontSize: '16px', padding: '10px 12px', width: '100%', boxSizing: 'border-box', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
    placeholder="Slogan"
    />
    <div class="acoes">
      <img v-if="img.length && img.indexOf('base64,') !== -1" :src="img" @click="$refs.in.click()">
      <img v-if="img.length && img.indexOf('base64,') === -1" :src="api + img" @click="$refs.in.click()">
      <img-icon @click="$refs.in.click()" v-if="!img.length" :options="{ width: '35px', height: '25px', color: '#CCCCCC', action: true }"/>
      <delete-icon @click="_UpdateFrenteLojaSlogan({ text: text, img: '' });img=''"/>
      <update-icon @click="_UpdateFrenteLojaSlogan({ text: text, img: img, filename: filename })"/>
    </div>
    <input ref="in" v-show="false" type="file" @change="inFile"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import InputReg from '../Produtos/Register/InputReg'
import ImgIcon from '../Icons/ImgIcon'
import UpdateIcon from '../Icons/UpdateIcon'
import DeleteIcon from '../Icons/DeleteIcon'
import api from '@/mixins/api'
import compressImage from '@/mixins/compressImage'
export default {
  name: 'SelectSlogan',
  components: { InputReg, ImgIcon, UpdateIcon, DeleteIcon },
  mixins: [api, compressImage],
  data () {
    return {
      text: '',
      img: '',
      filename: ''
    }
  },
  methods: {
    ...mapActions(['_UpdateFrenteLojaSlogan', 'GetFrenteLojaSlogan']),
    inFile (e) {
      for (let key in e.target.files) {
        if (key !== 'length' && key !== 'item') {
          this.getBase64(e.target.files[key])
        }
      }
    },
    getBase64 (file) {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = async () => {
        this.img = await this.compressImage(reader.result)
        this.filename = file.name
      }
      reader.onerror = (error) => {
        console.log('Error: ', error)
      }
    }
  },
  created () {
    this.GetFrenteLojaSlogan()
      .then(res => {
        this.text = res.text
        this.img = res.img
      })
  }
}
</script>

<style scoped>
.SelectSlogan {
  display: flex;
  align-items: center;
  gap: 12px;
}

.acoes {
  width: 150px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

img {
  width: 62px;
  height: 20px;
  object-fit: cover;
  border-radius: 3px;
  cursor: pointer;
}
</style>
